<div class="container">
  <ion-card class="card-container">
    <div class="header-image">
      <img [src]="IMAGES.UPS_ICON" />
    </div>

    <ion-card-header class="card-header">
      <ion-card-title class="body-header">
        {{ CONSTS.HEADER }}
      </ion-card-title>
      <ion-card-subtitle class="body-content">
        @if (hasLoginError) {
          <app-login-error-banner />
        }
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ng-container [ngTemplateOutlet]="currentUserTemplate()" />
      <ng-container [ngTemplateOutlet]="newUserTemplate()" />
    </ion-card-content>
  </ion-card>
</div>

<ng-template #currentUser>
  <div class="buttons">
    <ion-button class="choice-button" (click)="continue()">
      {{ CONSTS.CURRENT_USER.BUTTON_TEXT }}
    </ion-button>
  </div>
</ng-template>

<ng-template #newUser>
  <div class="user-container">
    <div class="body-text">
      {{ CONSTS.NEW_USER.BODY_TEXT }}
    </div>
    <a
      class="body-text"
      [href]="CONSTS.NEW_USER.MAIL_LINK"
      (click)="downloadAccessSteps()"
    >
      {{ CONSTS.NEW_USER.LINK_TEXT }}
    </a>
  </div>
</ng-template>
